import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description:
      'A dimension defining the association between space and cluster. This is used to assign spaces to clusters.',
    name: 'Space Cluster Assignment',
    partialId: PartialId.Standard.create('space_cluster_assignment'),
  },
  type: core.quiver.Resource.Type.DmsDimension,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsDimension>
